import { z } from 'zod';
import { DisciplineSchema, PricingTierSchema } from './common';

export const PricingItemSchema = z.object({
  key: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  discipline: DisciplineSchema,
  category: z.string().nullable(),
  subcategory: z.string().nullable(),
  unit: z.string(),
  priceBudget: z.number().nullable(),
  priceMid: z.number().nullable(),
  pricePremium: z.number().nullable(),
  manufacturer: z.string().nullable(),
  partNumber: z.string().nullable(),
});
export type PricingItem = z.infer<typeof PricingItemSchema>;

export const PricingOverrideSchema = z.object({
  tier: PricingTierSchema,
  overridePrice: z.number().positive(),
  reason: z.string().max(256).optional(),
});
export type PricingOverride = z.infer<typeof PricingOverrideSchema>;

export const PricingListQuerySchema = z.object({
  discipline: DisciplineSchema.optional(),
  category: z.string().optional(),
  search: z.string().max(128).optional(),
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(200).default(50),
});
export type PricingListQuery = z.infer<typeof PricingListQuerySchema>;
